import React, {useEffect} from 'react'
import type {IContentItem} from '@kontent-ai/delivery-sdk'
import {useRouter} from 'next/router'
import type {Block} from '@/_new-code/services/kontent-ai/types'

export type PearCommerceWidgetContentItem = IContentItem<{
	// No specific elements needed for this component
}>

export const PearCommerceWidget: Block<PearCommerceWidgetContentItem> = () => {
	const router = useRouter()

	useEffect(() => {
		const {sku, offerId} = router.query

		// Ensure sku and offerId are strings
		const skuString = Array.isArray(sku) ? sku[0] : sku
		const offerIdString = Array.isArray(offerId) ? offerId[0] : offerId

		// Only proceed if both sku and offerId are available
		if (skuString && offerIdString) {
			// Wait a bit for Pear Commerce to inject their iframe
			const updateIframe = (): void => {
				const pearFrame = document.querySelector(
					'#pear-pdp-target iframe'
				)
				if (pearFrame && pearFrame instanceof HTMLIFrameElement) {
					try {
						const currentUrl = new URL(pearFrame.src)

						const pathParts = currentUrl.pathname.split('/')
						const labelIndex = pathParts.findIndex(
							(part) => part === 'agnostic-pdp-label'
						)
						if (labelIndex !== -1 && pathParts[labelIndex + 1]) {
							pathParts[labelIndex + 1] = offerIdString
							currentUrl.pathname = pathParts.join('/')
						}

						const searchParams = new URLSearchParams(
							currentUrl.search
						)
						searchParams.set('sku', skuString)
						searchParams.set('offerId', offerIdString)
						searchParams.set(
							'childId',
							`pear-widget-iframe-wrap-${offerIdString}`
						)

						const parentUrl = searchParams.get('parentUrl')
						if (parentUrl) {
							try {
								const decodedParentUrl = new URL(
									decodeURIComponent(parentUrl)
								)

								const parentSearchParams = new URLSearchParams(
									decodedParentUrl.search
								)
								parentSearchParams.set('sku', skuString)
								parentSearchParams.set('offerId', offerIdString)

								decodedParentUrl.search =
									parentSearchParams.toString()

								searchParams.set(
									'parentUrl',
									decodedParentUrl.toString()
								)
							} catch (parentUrlError) {
								// eslint-disable-next-line no-console -- log error details
								console.error(
									'Error updating parentUrl:',
									parentUrlError
								)
							}
						}

						// Update the URL with new search parameters
						currentUrl.search = searchParams.toString()

						const newSrc = currentUrl.toString()
						pearFrame.src = newSrc
					} catch (error) {
						// eslint-disable-next-line no-console -- Log error details
						console.error('Error updating iframe URL:', error)
					}
				}
			}
			updateIframe()
		} else {
			// eslint-disable-next-line no-console -- Log error details
			console.error(
				'Missing required parameters - sku or offerId not found'
			)
		}
	}, [router.query])

	return (
		<div
			data-kontent-element-codename="pear_commerce_widget_guidelines"
			id="pear-pdp-target"
		>
			{/* Pear Commerce will inject its content here */}
		</div>
	)
}
